export const SET_ADVISORS = "SET_ADVISORS";
export const SET_STUDENTS = "SET_STUDENTS";
export const UPDATE_STUDENTS = "UPDATE_STUDENTS";
export const SET_INFO = "SET_INFO";

export function setAdvisors(advisors) {
	return {
		type: SET_ADVISORS,
		advisors: advisors,
	};
}

export function setStudents(students) {
	return {
		type: SET_STUDENTS,
		students: students,
	};
}

export function setUpdateStudents(students) {
	return {
		type: UPDATE_STUDENTS,
		students: students,
	};
}

export function setInfo(info) {
	return {
		type: SET_INFO,
		info: info,
	};
}
